import { render, staticRenderFns } from "./UpdateBusinessMemberNickName.vue?vue&type=template&id=038c2497"
import script from "./UpdateBusinessMemberNickName.vue?vue&type=script&lang=js"
export * from "./UpdateBusinessMemberNickName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports